import api from './services/mkm.api.js'

const resource = '/pruefungsordnung'

export default {
    getVorhandene(musikschuleId) {
        return api.get(`${resource}/${musikschuleId}`)
    },
    senden(payload) {
        return api.post(`${resource}`, payload)
    },
    getMusikschulen() {
        return api.get(`${resource}/musikschulen`)
    }
}